var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',{attrs:{"color":"accent","size":_vm.size}},[_c('div',{staticClass:"image",style:({ background: _vm.gradient, width: _vm.sizes, height: _vm.sizes })})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }